<app-navbar></app-navbar>

<div id="main-content" class="animated fadeIn">
  <div class="container-fluid">

    <!-- contenido-->
    <div class="block-header">
      <div class="row clearfix">
        <div class="col-md-6 col-sm-12">
          <h1 class="color">Gestor de Tareas</h1>
          <div class="row" style="margin-top: 10px;">
            <div class="col col-md-6 col-sm-6">
              <h6 style="margin-top: 10px;">Proyectos</h6>
            </div>
            <div class="col col-md-6 col-sm-6">
              <!-- <span class="" id="add_cat" style="cursor: pointer;" > -->
              <button *ngIf="agregar_proyecto == false" class="btn btn-primary btn-round" (click)="verform()">Agregar
                Proyectos</button>

              <button *ngIf="agregar_proyecto == true" class="btn btn-danger btn-round"
                (click)="cerrarform()">Cerrar</button>
              <!-- </span> -->
            </div>
          </div>


        </div>

      </div>

      <div class="card animated fadeIn" style="margin-top: 10px;" *ngIf="agregar_proyecto == true">
        <div class="body">


          <form #createCatForm="ngForm" (ngSubmit)="onSubmit(createCatForm)" class="">
            <div class="row" style="">


              <div class="col-md-4 col-sm-12">
                <input type="text" #categoria="ngModel" [(ngModel)]="cat.categoria" name="categoria"
                  placeholder="Nombre del Proyecto" class="form-control txt_cat" style="width: 100%;" id="txt_cat"
                  required>
                <span *ngIf="!categoria.valid && categoria.touched">
                  El nombre del proyecto no es válido
                </span>
              </div>
              <div class="col-md-4 col-sm-12">
                <div class="row">
                  <div class="col-2"><label>Color:</label></div>
                  <div class="col-8" id="color_proyect">
                    <input type="color" id="element" [(value)]="cat.color" [(ngModel)]="cat.color" name="color"
                      class="form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <button type="submit" class="btn btn-primary  btn-round btn-block"
                  [disabled]="!createCatForm.form.valid">
                  <i class="fa " aria-hidden="true"
                    [ngClass]="{ 'fa-sign-in':!loading, ' fa-refresh fa-spin':loading }"></i>
                  Guardar
                </button>
              </div>


              <div *ngIf="status == 'error'">
                <br>
                No se guardo el proyecto, Intentelo de nuevo.
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="text-center">
      <i class="fa fa-spinner fa-spin" style="font-size: 25px;" aria-hidden="true" *ngIf="cargando == true"></i>
      {{message}}
    </div>
    <!-- se debe duplicar el card -->
    <div class="card  col-sm-6 col-md-3" style="cursor:poiner  " *ngFor="let cat of categoria"
      [ngClass]="{margen: cat.cliente == 1 }">
      <div class="header"
        style="background-color: {{cat.color}}; padding-bottom: 5px; border-radius: 10px 10px 0px 0px;"></div>
      <div class="body" style="cursor: pointer; border-radius: 0px 0px 10px 10px;" (click)="verActividades(cat)">
        <p>{{cat.categoria}}</p>
      </div>
      <div class="footer" style="float: right;" *ngIf="cat.cliente != 1">
        <i style="margin-left:10px; cursor: pointer; padding-top: 5px;" class="fa fa-edit text-info"
          (click)="edit_cat_table(cat)"></i>
        <i style="margin-left:10px; cursor: pointer; padding-top: 5px;" class="fa fa-trash-o text-danger"
          (click)="del_cat_table(cat)"></i>
      </div>
    </div>

    <!-- end contenido-->



  </div>
</div>

<!-- Modal -->
<div class="modal fade " id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #editCatForm="ngForm" (ngSubmit)="onSubmitEdit(editCatForm)" class="">
        <div class="modal-body">
          <div class="row" style="">

            <div class="col-md-12 col-sm-12">
              <div class="col-12"><label>Nombre del Proyecto:</label></div>
              <input type="text" #categoria_edit="ngModel" [(ngModel)]="edit_cat.categoria" [value]="edit_cat.categoria"
                name="categoria_edit" placeholder="Nombre del Proyecto" class="form-control txt_cat"
                style="width: 100%;" id="txt_cat_color">
            </div>

            <div class="col-md-12 ">
              <div class="col-md-12 "><label>Color:</label></div>
              <div class="col-md-12  container" id="color_proyect">
                <input type="color" id="element" [(value)]="edit_cat.color" [(ngModel)]="edit_cat.color" name="color"
                  class="form-control" />
              </div>
            </div>

            <!-- <input type="hidden" #id_cat="ngModel" [(ngModel)]="edit_cat.id" [value]="id_edit" name="id_edit"> -->
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary  btn-round " [disabled]="!editCatForm.form.valid">
            <i class="fa " aria-hidden="true"
              [ngClass]="{ 'fa-sign-in':!loading_edit, ' fa-refresh fa-spin':loading_edit }"></i>
            Editar Proyecto
          </button>

        </div>
      </form>
    </div>
  </div>
</div>